import { createRouter, createWebHistory } from "vue-router";
import About from "@/views/About.vue";
import TaskSection from "@/Components/TaskSection.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: TaskSection,
    props: true,
  },
  {
    path: "/about",
    name: "About",
    component: About,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
